import api from "@/services/api";

// Reuse the main API client so sections use the same backend and auth flow
// as teachers/news endpoints.
export default api;
